import styled from 'styled-components/macro';
import { TagChip as Tag } from '@cognite/cogs.js';
import { RuleSeverity } from 'types/dt-graphql-apollo-v2';
import { wordFromUpperCaseToCapitilized } from 'utils/misc';

export const SeverityTag = ({ severity }: { severity: RuleSeverity }) => (
  <StyledSeverityTag
    severity={severity}
    label={wordFromUpperCaseToCapitilized(severity)}
    size="small"
  />
);

const StyledSeverityTag = styled(Tag)<{ severity: RuleSeverity }>`
  border: 0 !important;
  border-radius: var(--cogs-border-radius--small);
  ${({ severity }) =>
    severity === RuleSeverity.Critical &&
    `    
      color: var(--cogs-text-danger) !important;
      background: var(--cogs-bg-status-small--danger) !important;
    `}
  ${({ severity }) =>
    severity === RuleSeverity.Warning &&
    `
      color: var(--cogs-text-warning) !important;
      background: var(--cogs-bg-status-small--warning) !important;
    `}
  ${({ severity }) =>
    severity === RuleSeverity.Minor &&
    `
      color: var(--cogs-text-status-small--default) !important;
      background: var(--cogs-bg-status-small--default) !important;
    `}
  ${({ severity }) =>
    severity === RuleSeverity.None &&
    `
      color: var(--cogs-text-status-small--unknown) !important;
      background: var(--cogs-bg-status-small--unknown) !important;
    `}
`;
